import { useEffect, useState } from "react"

export type UnitType = 'cm' | 'in'

const lsKey = 'unit'

const useUnit = () => {
    const [unit, set] = useState<UnitType | ''>((localStorage.getItem(lsKey) as UnitType) || '')

    const setUnit = (v: UnitType) => {
        localStorage.setItem(lsKey, v)
        // set(v)
        window.dispatchEvent(new Event('unitChange'))
    }

    useEffect(() => {
        const listenStorageChange = () => {
            set((localStorage.getItem(lsKey) as UnitType) || '')
        }

        window.addEventListener("unitChange", listenStorageChange)
        return () => window.removeEventListener("unitChange", listenStorageChange)
    }, [])

    return { unit, setUnit }
}

export default useUnit

export type WeightUnitType = 'kg' | 'lbs'

const lsWeightKey = 'weightUnit'

export const useWeightUnit = () => {
    const [unit, set] = useState<WeightUnitType | ''>((localStorage.getItem(lsWeightKey) as WeightUnitType) || '')

    const setUnit = (v: WeightUnitType) => {
        localStorage.setItem(lsWeightKey, v)
        // set(v)
        window.dispatchEvent(new Event('weightUnitChange'))
    }

    useEffect(() => {
        const listenStorageChange = () => {
            set((localStorage.getItem(lsWeightKey) as WeightUnitType) || '')
        }

        window.addEventListener("weightUnitChange", listenStorageChange)
        return () => window.removeEventListener("weightUnitChange", listenStorageChange)
    }, [])

    return { unit, setUnit }
}